import React from 'react';
import Nav from '../../components/Nav';
import Footer from '../../components/Footer';

const Accessibility = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col pt-14 sm:pt-16">
      <Nav />
      <main className="flex-1 max-w-5xl mx-auto px-3 sm:px-6 lg:px-8 py-3 sm:py-5 w-full space-y-3.5 sm:space-y-5">
        
        {/* Compact Hero Banner */}
        <div className="bg-gradient-to-r from-emerald-800 via-teal-900 to-emerald-900 rounded-xl sm:rounded-2xl p-3.5 sm:py-4 sm:px-6 text-white text-center space-y-1 shadow-xs">
          <span className="bg-emerald-500/30 text-emerald-300 border border-emerald-400/40 text-[9px] font-extrabold px-2 py-0.5 rounded-full uppercase tracking-wider">
            Inclusive Platform
          </span>
          <h1 className="text-sm sm:text-lg md:text-xl font-black leading-snug">Accessibility Statement</h1>
          <p className="text-emerald-100/90 text-[11px] sm:text-xs max-w-xl mx-auto">
            Last Updated: August 26, 2026
          </p>
        </div>

        <div className="bg-white p-4 sm:p-6 rounded-xl sm:rounded-2xl border border-gray-100 shadow-2xs space-y-3 sm:space-y-4 text-xs sm:text-sm text-gray-600 leading-normal">
          <section className="space-y-1">
            <h2 className="text-xs sm:text-base font-bold text-gray-900">Our Commitment</h2>
            <p className="text-[11px] sm:text-xs">E-Learning Hub is committed to ensuring digital accessibility for people with disabilities. We continuously audit and refine our user interfaces to align with Web Content Accessibility Guidelines (WCAG 2.1 Level AA).</p>
          </section>

          <section className="space-y-1">
            <h2 className="text-xs sm:text-base font-bold text-gray-900">Key Accessibility Features</h2>
            <ul className="list-disc pl-5 space-y-1 text-[11px] sm:text-xs">
              <li>High contrast dark mode & light mode color options</li>
              <li>Keyboard navigable menus and interactive elements</li>
              <li>Screen reader compatible ARIA labels on all major controls</li>
              <li>Video captions and transcript support for course lectures</li>
            </ul>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Accessibility;
